import PropTypes from 'prop-types';
import _ from 'underscore';
import { ImageExperienceImage } from '@bingads-webui-campaign-react/image-experience';
import C from './constants';

// { VideoMedia16X9Thumbnail: ImageExperienceImage, ... }
export const CustomThumbnailRecordType = PropTypes.shape(_.values(C.videoTypeToThumbnailType)
  .reduce((acc, current) => {
    acc[current] = PropTypes.instanceOf(ImageExperienceImage);
    return acc;
  }, {}));

export const CaptionType = PropTypes.arrayOf(PropTypes.shape({
  Id: PropTypes.string,
  Name: PropTypes.string,
  Lcid: PropTypes.number.isRequired,
  Format: PropTypes.string.isRequired,
  FileExtension: PropTypes.string,
  File: PropTypes.instanceOf(File),
}));
